import { lazy, Suspense } from "react";
import TelemedBanner from "./TelemedBanner";
import TelemedProviders from "./TelemedProviders";

const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));

const TelemedFeature = lazy(() => import("./TelemedFeature"));
const TelemedFit = lazy(() => import("./TelemedFit"));
const TelemedFunction = lazy(() => import("./TelemedFunction"));
const TelemedPlatform = lazy(() => import("./TelemedPlatform"));
const TelemedRemote = lazy(() => import("./TelemedRemote"));
const TelemedSoftware = lazy(() => import("./TelemedSoftware"));
const TelemedSolution = lazy(() => import("./TelemedSolution"));

const faqData = [
  {
    id: "0",
    question: "01. What services does Mobility Infotech's platform offer for Primary Care?",
    answer:
      "Mobility Infotech provides solutions for routine checkups, chronic condition management, and preventive healthcare services. Patients can connect with primary care providers for timely medical attention and interventions.",
  },
  {
    id: "1",
    question: "02. How does the platform support Specialty Care?",
    answer:
      "The platform simplifies access to specialists in cardiology, dermatology, and more. It enables seamless referrals, second opinions, and treatment plans for comprehensive specialized care.",
  },
  {
    id: "2",
    question: "03. Can this platform assist with Pediatric Care?",
    answer:
      "The Pediatric Care solutions are tailored to children's healthcare needs, offering virtual consultations, immunization tracking, and wellness monitoring for timely diagnosis and treatment.",
  },
  {
    id: "3",
    question: "04. What are the benefits of Emergency Care through this platform?",
    answer:
      "Emergency Care services prioritize immediate medical attention through swift consultations and triage systems, ensuring timely care and improved outcomes in critical situations.",
  },
  {
    id: "4",
    question: "05. How does the Student Care Service work?",
    answer:
      "Student Care Services provide secure and user-friendly features, such as virtual consultations, mental health assistance, and wellness programs, ensuring students receive proper care without disrupting their education.",
  },
  {
    id: "5",
    question: "06. Can patients receive care at home using this platform?",
    answer:
      "Absolutely! The Home Healthcare feature supports follow-up consultations, chronic disease management, and elderly care, allowing patients to conveniently receive medical attention at home.",
  },
  {
    id: "6",
    question:
      "07. What solutions are available for organizations?",
    answer:
      "Healthcare for Organizations includes virtual consultations, wellness programs, and preventive care services tailored to ensure employees' health and boost workplace productivity.",
  },
  {
    id: "7",
    question: "08. How does the platform ensure Multi-Specialty care?",
    answer:
      "The Multi-Specialty feature integrates various specialties on a single platform, enabling coordinated treatment plans and holistic healthcare solutions for patients.",
  },
];

export default function Telemedicine() {
  return (
    <>
      <TelemedBanner />
      <TelemedProviders />

      <Suspense fallback={null}>
        <TelemedSoftware />
        <TelemedFunction />
        <TelemedRemote />
        <TelemedPlatform />
        <TelemedFeature />
        <TelemedSolution />
        <TelemedFit />
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
